"use client";
import {
  Stack,
  Table,
  // TableContainer,
  // Tbody,
  // Td,
  // Th,
  // Thead,
  // Tr,
  Box,
  SimpleGrid,
} from "@chakra-ui/react";
import { Heading, Text } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";

type TableDataProps = {
  heading?: string;
  text?: string;
  columns: string[];
  data: {
    feature: string;
    [key: string]: string;
  }[];
};

const ComparisonTable = (props: TableDataProps) => {
  const { heading, text, columns, data } = props;
  const headingVariant = useHeadingVariant();
  return (
    <Stack gap={8}>
      {heading && (
        <Heading as="h2" variant={headingVariant} textAlign={"center"}>
          {heading}
        </Heading>
      )}
      {text && (
        <Text variant={"body2"} textAlign={"center"}>
          {text}
        </Text>
      )}

      <Box overflowX="auto" w="100%" maxW="100%">
        <Table.Root
          striped
          display={{ base: "none", md: "table" }}
          boxShadow={"xl"}
          borderColor={"rgb(237,242,247)"}
          borderWidth={"2px"}
          w="100%"
          minW="100%"
        >
          <Table.Header>
            <Table.Row w="100%">
              <Table.ColumnHeader
                color="black"
                fontSize="23px"
                py={6}
                textTransform={"none"}
              >
                Feature
              </Table.ColumnHeader>
              {columns.map((column, index) => (
                <Table.ColumnHeader
                  key={index}
                  color="black"
                  fontSize="23px"
                  py={6}
                  textTransform={"none"}
                >
                  {column}
                </Table.ColumnHeader>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.map((item, index) => (
              <Table.Row key={index}>
                <Table.Cell fontWeight={600} fontSize={"17px"}>
                  {item.feature}
                </Table.Cell>
                {columns.map((column, colIndex) => (
                  <Table.Cell key={colIndex} fontSize={"17px"}>
                    {item[column]}
                  </Table.Cell>
                ))}
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Box>

      <Stack display={{ base: "flex", md: "none" }} gap={4}>
        {data.map((item, index) => (
          <Box key={index} p={4} borderWidth="1px" borderRadius="md" boxShadow="md">
            <Text fontSize="lg" fontWeight="bold" mb={2}>
              {item.feature}
            </Text>
            <SimpleGrid columns={{ base: 1, sm: 2 }} gap={3}>
              {columns.map((column, colIndex) => (
                <Box key={colIndex}>
                  <Text fontSize="md" fontWeight="bold" color="text.100">
                    {column}
                  </Text>
                  <Text mt={1} p={2} bg="gray.100" borderRadius="md" fontSize="md">
                    {item[column]}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </Box>
        ))}
      </Stack>
    </Stack>
  );
};

export default ComparisonTable;
